import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { Order } from "src/app/models/order";
import { ApiService } from "src/app/services/api.service";
import { GridsterService } from "src/app/services/gridster.service";

@Component({
  selector: "app-selected-order-trade",
  templateUrl: "./selected-order-trade.component.html",
  styleUrls: ["./selected-order-trade.component.scss"],
})
export class SelectedOrderTradeComponent implements OnInit {
  order: any;
  orderHistory: any;
  orderNumber: any;
  noData: boolean = false;
  mapFixStatusColor = new Map([
    ["0", "white"],
    ["1", "#5aff55"],
    ["2", "darkgreen"],
    ["3", "yellow"],
    ["4", "#ff7200"],
    ["5", "#550eff"],
    ["6", "yellow"],
    ["8", "darkred"],
    ["9", "gray"],
    ["A", "yellow"],
    ["C", "darkred"],
    ["E", "yellow"],
    ["H", "darkred"],
    ["N", "darkred"],
    ["R", "yellow"],
    ["W", "yellow"],
    ["P", "yellow"],
    ["X", "yellow"],
    ["Y", "darkred"],
    ["Z", "cyan"],
  ]);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: string,
    private apiService: ApiService,
    public dialogRef: MatDialogRef<SelectedOrderTradeComponent>,
    public translate: TranslateService
  ) {
    if (this.data["order"] != null) {
      this.fetchHistory(this.data["order"]);
    }
  }

  ngOnInit(): void {}

  fetchHistory(orderNumber) {
    this.apiService.fetchOrderHistory(orderNumber).subscribe((res) => {
      this.noData = true;

      this.order = res;

      this.orderHistory = this.order.OrderHistory;
    });
  }
  getBackgroundColor(fixStatusCode) {
    if (fixStatusCode) {
      let backgroundColor = this.mapFixStatusColor.get(fixStatusCode);
      return backgroundColor;
    }
  }
  closeDialog() {
    this.dialogRef.close();
  }

  titleCancelOrder(status): boolean {
    if (status == 9 || status == 10 || status == 3) {
      return true;
    } else {
      return false;
    }
  }
}
